require('./bootstrap');

// import store from '@/store';
// import Alpine from 'alpinejs';
import lowerCase from 'lodash/lowerCase';

// import Toasted from 'vue-toasted';

import VueTouchEvents from 'vue2-touch-events';
import PortalVue from 'portal-vue';
import VTooltip from 'v-tooltip';
// import Mousetrap from 'mousetrap';
// import Ads from 'vue-google-adsense';
import SocialSharing from 'vue-social-sharing';
import Embed from 'v-video-embed';

import AppMixin from './mixins/app';
import CookiesMixin from './mixins/cookies';
import DatesMixin from './mixins/dates';
import NumbersMixin from './mixins/numbers';
import TimezoneMixin from './mixins/timezone';
import ResponsiveMixin from './mixins/responsive';
import LocaleMixin from './mixins/locale';

import Vue from 'vue';

// import('../css/tailwind2.css');

/**
 * @see https://www.digitalocean.com/community/tutorials/vuejs-global-event-bus
 */
window.Vue = Vue;
window.Bus = new Vue();

require('./plugins/sentry');

Vue.config.productionTip = false;

// @todo only register if mobile?
Vue.use(VueTouchEvents);
// Vue.use(require('vue-script2'));
// Vue.use(Ads.Adsense);
// Vue.use(Ads.InArticleAdsense);
// Vue.use(Ads.InFeedAdsense);
Vue.use(PortalVue);
Vue.use(VTooltip, {
    popover: {
        defaultTrigger: 'hover',
        defaultArrowClass: 'arrow'
    }
});
Vue.use(SocialSharing, {
    // networks: {
    //   wechat: 'https://wechat.com/share?url=@url&title=@title'
    // }
});
Vue.use(Embed);
/*Vue.use(Toasted, {
    router,
    theme: 'promo',
    position: 'bottom-right',
    duration: 6000,
});*/

if (typeof route !== 'undefined' && route) {
    Vue.mixin({
        methods: { route }
    });
}

Vue.mixin(AppMixin);
Vue.mixin(CookiesMixin);
Vue.mixin(DatesMixin);
Vue.mixin(NumbersMixin);
Vue.mixin(TimezoneMixin);
Vue.mixin(ResponsiveMixin);
Vue.mixin(LocaleMixin);

/*
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle, faShareSquare, faBell, faBellSlash, faExternalLinkAlt, faFire, faFireAlt, faBolt, faSearchLocation, faStore, faRedoAlt, faPlus, faPlusCircle, faTimes, faCircleNotch, faChevronRight, faChevronDown, faBookmark, faShippingFast, faHeart } from '@fortawesome/free-solid-svg-icons'
import { faCommentDots, faEnvelope, faCalendarAlt, faCalendarCheck, faClock, faArrowAltCircleDown, faStickyNote } from '@fortawesome/free-regular-svg-icons'
import { faFacebook, faFacebookF, faTwitter, faDiscord, faInstagram, faPinterest } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faInfoCircle, faShareSquare, faBell, faBellSlash, faCommentDots, faEnvelope, faExternalLinkAlt, faFire, faFireAlt, faBolt, faSearchLocation, faStore, faRedoAlt, faPlus, faPlusCircle, faTimes, faCircleNotch, faChevronRight, faChevronDown, faBookmark, faShippingFast, faHeart, faCalendarAlt, faCalendarCheck, faClock, faArrowAltCircleDown, faStickyNote, faFacebook, faFacebookF, faTwitter, faDiscord, faInstagram, faPinterest);
Vue.component('fa-icon', FontAwesomeIcon);
*/

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// import AppView from "./components/App.vue";

const app = new Vue({
    // router: router,

    el: '#app',

    // render: h => h(AppView)

    created() {
        this.trackTimezone();
    }
});

Echo.channel("app")
    .listen("refresh", e => {
        window.location.reload();
    })
    .listen(".listing.checked", e => {
        Bus.$emit("productListingChecked", e.listing);
    })
    .listen(".listing.stocked", e => {
        Bus.$emit("productListingStocked", e.listing);
    })
    .listen(".listing.unstocked", e => {
        Bus.$emit("productListingUnstocked", e.listing);
    })
    .listen(".listing.created", e => {
        Bus.$emit("productListingCreated", e.listing);
    });

/*if (window.App && window.App.user) {
    Echo.private('users.' + window.App.user.id)
        .listen(".product.user_subscribed", e => {});
}*/

window.trackProductClick = function (model, url, type, store) {
    // navigator.sendBeacon

    if (store) {
        // @todo switch to beacons?
        window.axios.get("/tc", {
            params: {
                k  : model.id,
                t  : 'p',
                u  : url,
                ts : new Date().getTime()
            }
        })
            .then(response => {})
            .catch(response => {});
    }

    if (typeof gtag !== 'undefined') {
        /**
         * @see https://support.google.com/google-ads/answer/7548399
         * @see https://developers.google.com/gtagjs/reference/event
         * @see https://developers.google.com/gtagjs/reference/parameter
         * @see https://developers.google.com/analytics/devguides/collection/gtagjs/events
         */
        gtag('event', 'conversion', {
            'send_to': 'AW-788361276/jbR0CKH_2tEBELzg9fcC',
            'name': model.name,
            'value': 1.0,
            // 'currency': 'USD',
            'content_id': model.id,
            'content_type': type
        });

        gtag('event', 'click', {
            'send_to': process.env.MIX_GOOGLE_ANALYTICS_ID,
            'event_category': lowerCase(type),
            'event_label': model.name,
            'value': 1.0
        });
    }

    /**
     * @see https://developers.google.com/analytics/devguides/collection/upgrade/analyticsjs
     * @see https://developers.google.com/analytics/devguides/collection/analyticsjs
     * @see https://developers.google.com/analytics/devguides/collection/analyticsjs/how-analyticsjs-works
     * @see https://developers.google.com/analytics/devguides/collection/analyticsjs/sending-hits
     */
    if (typeof ga !== 'undefined') {
        ga('send', {
            hitType: 'event',
            eventCategory: lowerCase(type),
            eventAction: 'click',
            eventLabel: model.name,
            eventValue: 1.0
        });
    }
};

/**
 * @see https://developers.google.com/web/fundamentals/app-install-banners/native
 */
/*var deferredPrompt;
window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  e.preventDefault();

  // Stash the event so it can be triggered later.
  deferredPrompt = e;
});*/

// @todo should this be $once?
Bus.$on('onesignal.subscribed', function (onesignalId) {
    const app = window.App || {};
    const user = app.user || null;
    if (!user) return;

    window.axios.post('/api/user/connections', {
        provider    : 'onesignal',
        provider_id : onesignalId
    })
    .then(response => {})
    .catch(response => {});
});

// export default class Promo {}
